<div class="min-h-screen flex items-center justify-center bg-gray-50 px-4">
  <div class="w-full max-w-md bg-white rounded-lg shadow p-8">
    <h1 class="text-2xl font-semibold mb-1">Set your password</h1>

    <ng-container *ngIf="!isComplete">
      <p class="text-sm text-gray-600 mb-6" *ngIf="email">Setting the password for <span class="font-medium">{{ email }}</span>.</p>

      <form [formGroup]="form" (ngSubmit)="onSubmit()" class="space-y-4">
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1" for="password">New password</label>
          <input id="password" type="password" formControlName="password" autocomplete="new-password"
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <p class="text-xs text-gray-500 mt-1">At least 8 characters with upper, lower, number, and symbol.</p>
        </div>
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-1" for="confirmPassword">Confirm password</label>
          <input id="confirmPassword" type="password" formControlName="confirmPassword" autocomplete="new-password"
            class="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
          <p class="text-xs text-red-600 mt-1" *ngIf="form.errors?.['passwordMismatch']">Passwords don't match.</p>
        </div>
        <button type="submit" [disabled]="form.invalid || isSubmitting"
          class="w-full bg-blue-600 text-white font-medium py-2 rounded-md hover:bg-blue-700 disabled:opacity-50">
          {{ isSubmitting ? 'Saving…' : 'Set password' }}
        </button>
      </form>
    </ng-container>

    <ng-container *ngIf="isComplete">
      <p class="text-sm text-gray-700 mb-6">
        Your password has been set. You can now sign in to your account.
      </p>
      <button (click)="goToLogin()"
        class="w-full bg-blue-600 text-white font-medium py-2 rounded-md hover:bg-blue-700">
        Sign in
      </button>
    </ng-container>
  </div>
</div>
